(function (upp) {
    'use strict';

    upp.service('aboutService', ['appi', '$q', '$sce',
        function (appi, $q, $sce) {
            var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE;

            /**
             * Retrieves the configuration and order of the about modules
             *
             * @method getInfo
             * @return {Promise} Returns a promise that will be fulfilled(about config) or rejected(error)
             */
            var getInfo = (function ($q, angular) {
                var info, _copy = angular.copy;

                return function () {
                    var deferred = $q.defer();

                    if (info) {
                        deferred.resolve(info);
                    } else {
                        appi.http.get(URL_API_REST_SERVER + 'v2/about')
                            .then(function (response) {
                                info = _copy(response.data);
                                deferred.resolve(info);
                            }, function (err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                };
            }($q, angular));

            return {
                getInfo: getInfo
            };

        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/about/services/about-services.js